// CSRF tokens for API
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
    window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;

    $.ajaxSetup({
        headers: {
            "X-CSRF-TOKEN": token.content,
        },
    });
} else {
    console.error("CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token");
}

// Vue
import VeeValidate from "vee-validate";
import Vue from "vue";
import VModal from "vue-js-modal";
import * as uiv from "uiv";

// Vue Bootstrap
import BootstrapVue from "bootstrap-vue";

// Vue Toast
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

// Validation
const dictionary = {
    en: {
        messages: {
            required: "This field is required.",
            confirmed: "Passwords must match",
        },
    },
};
Vue.use(BootstrapVue);
Vue.use(VeeValidate, {
    locale: "en",
    dictionary: dictionary,
});

Vue.use(uiv);
Vue.use(VModal, {dialog: true});

Vue.component("hidden-string", require("./components/HiddenString.vue").default);

Vue.use(Toast, {
    transition: "Vue-Toastification__bounce",
    maxToasts: 20,
    newestOnTop: true,
});

const app = new Vue(_.defaults(window.vueApp, {
      el: "#app",
      components: {
          "accept-terms": require("./components/AcceptTerms.vue").default,
          "agreement-signatories": require("./components/AgreementSignatories.vue").default,
          "auto-complete": require("./components/AutoComplete.vue").default,
          "bank-account-verification": require("./components/BankAccountVerification.vue").default,
          "channel-lineup": require("./components/ChannelLineup.vue").default,
          "compensation-requests": require("./components/CompensationRequests.vue").default,
          "network-invite": require("./components/NetworkInvite.vue").default,
          "network-password-change": require("./components/NetworkPasswordChange.vue").default,
          "opt-out-modal": require("./components/OptOutModal.vue").default,
          "email-unsubscribe-modal": require("./components/EmailUnsubscribeModal.vue").default,
          "property-search": require("./components/PropertySearch.vue").default,
          "pulse-motiv": require("./components/PulseMotiv.vue").default,
          "site-manager-network-access": require("./components/SiteManagerNetworkAccess.vue").default,
          "stripe-source-bank-account": require("./components/StripeSourceBankAccount.vue").default,
          "stripe-source-card": require("./components/StripeSourceCard.vue").default,
          "tracking-tabs": require("./components/TrackingTabs.vue").default,
          "unit-search": require("./components/UnitSearch.vue").default,
          "unit-search-2": require("./components/UnitSearchCms2.vue").default,
          "network-access-dtc-owner": require("./components/NetworkAccessDtcOwner.vue").default,
          "project-register-form": require("./components/ProjectRegisterForm.vue").default,
          "update-user-profile": require("./components/UpdateUserProfile.vue").default,
          "enrollment-blocked-lease-renew-widget": require("./components/EnrollmentBlockedLeaseRenewWidget.vue").default,
          "multi-signature-download": require("./components/MultiSignatureDownload").default,
      },

        data() {
            return {};
        },

        methods: {
            handleErrors(err) {
                var errors = _.get(err, "response.data.errors");
                var message = _.get(err, "response.data.message", null);

                console.error(err);

                if (_.isObject(errors) && Object.keys(errors).length > 0) {
                    _.each(errors, (messages, errorKey) => {
                        if (_.isString(messages)) {
                            this.$notify({
                                type: "danger",
                                placement: "top-left",
                                title: messages,
                            });
                        } else if (_.isArray(messages)) {
                            var errorFields = _.split(errorKey, ".");

                            if (errorFields.length === 2) {
                                var errorField = errorFields[0] + "[" + errorFields[1] + "]";

                                _.each(messages, (message) => {
                                    this.errors.add({
                                        field: errorField,
                                        msg: message,
                                    });
                                });
                            }
                        }
                    });
                } else {
                    this.$notify({
                        type: "danger",
                        placement: "top-left",
                        title: "Something went wrong, please refresh your browser and try again",
                    });
                }
            },
        },
    })
);

(function ($) {
    require("./components/serialize-object");

    require("./components/form-validate");
    require("./components/submit-button");
    require("./components/post-button");
    require("./components/script-link");
    require("./components/event-link");
    require("./components/chat-link");

    require("./components/transparent-bar");
    require("./components/side-bar");

    // Views
    require("./views/reimbursements.view.js");
})(jQuery);
